import { memo } from 'react';
import { useSignalR } from '@/hooks/useSignalR';
import { ProgressBar } from '@/components/ProgressBar';

/**
 * AdminProgressBar component displays the progress bar for admin operations.
 *
 * **Why this component exists:**
 * This component is separated from AdminSessionsTable to isolate the consumption
 * of `progressState` from SignalR context. This prevents AdminSessionsTable from
 * re-rendering on every SignalR progress update, which was causing browser lockups
 * due to expensive table re-renders during refresh operations.
 *
 * By isolating this component, only the small progress bar re-renders when SignalR
 * sends updates, while the large table component remains stable.
 */
function AdminProgressBarComponent() {
  const { progressState } = useSignalR();

  // Only show progress bar if there's an active SessionCacheRefresh operation
  if (!progressState.SessionCacheRefresh) {
    return null;
  }

  return (
    <div style={{ marginBottom: '1rem' }}>
      <ProgressBar progress={progressState.SessionCacheRefresh} />
    </div>
  );
}

/**
 * Memoized version of AdminProgressBar for performance optimization.
 * Export this component instead of the base component.
 */
export const AdminProgressBar = memo(AdminProgressBarComponent);

AdminProgressBar.displayName = 'AdminProgressBar';
